import { ActiveLeadDetailsModal, LeadDetailsModal } from "@forwardflow/modals";
import { useActiveLeadDetailsModalStore } from "@forwardflow/store/modal/ActiveLeadDetailsModal";
import { useLeadDetailsModalStore } from "@forwardflow/store/modal/LeadDetailsModal";
import { Button, SearchField } from "@forwardflow/ui";
import Icon from "@forwardflow/ui/Icons";
import { useState } from "react";

export const CampaignLeadSourceList: React.FC = () => {
   const [searchTerm, setSearchTerm] = useState("");
   const [isPausedFilterActive, setIsPausedFilterActive] = useState(false);
   const [isAllFilterActive, setIsAllFilterActive] = useState(true);
   const [isActiveFilterActive, setIsActiveFilterActive] = useState(false);
   const [isInactiveFilterActive, setIsInactiveFilterActive] = useState(false);
   const { openLeadDetailsModal } = useLeadDetailsModalStore();
   const { openActiveLeadDetailsModal } = useActiveLeadDetailsModalStore();

   const dataSource = [
      {
         Lead_Source: "Facebook leads",
         Total_leads: 1256,
         App_set: 124,
         App_rate: "10.4%",
         Status: "Active",
      },
      {
         Lead_Source: "John",
         Total_leads: 124,
         App_set: 124,
         App_rate: "10.4%",
         Status: "Active",
      },
      {
         Lead_Source: "Facebook leads",
         Total_leads: 1256,
         App_set: 124,
         App_rate: "10.4%",
         Status: "Paused",
      },
      {
         Lead_Source: "Facebook leads",
         Total_leads: 1256,
         App_set: 124,
         App_rate: "10.4%",
         Status: "Paused",
      },
      {
         Lead_Source: "Facebook leads",
         Total_leads: 1256,
         App_set: 124,
         App_rate: "10.4%",
         Status: "Inactive",
      },
      {
         Lead_Source: "Facebook leads",
         Total_leads: 1256,
         App_set: 124,
         App_rate: "10.4%",
         Status: "Inactive",
      },
   ];
   const [filteredData, setFilteredData] = useState(dataSource);

   const columns = [
      {
         title: "Lead Source",
      },
      {
         title: "Total leads",
      },
      {
         title: "App.set",
      },
      {
         title: "App.rate",
      },
      {
         title: "Status",
      },
   ];

   const handleSearch = (value: string) => {
      setSearchTerm(value);
      if (value !== "") {
         const filtered = dataSource.filter((item) =>
            item.Lead_Source.toLowerCase().includes(value.toLowerCase())
         );
         setFilteredData(filtered);
      } else {
         setFilteredData(dataSource);
      }
   };

   const handleFilter = (filterType: string) => {
      const filtered =
         filterType === "All"
            ? dataSource
            : dataSource.filter((item) => item.Status === filterType);

      setFilteredData(filtered);
      setIsActiveFilterActive(filterType === "Active");
      setIsPausedFilterActive(filterType === "Paused");
      setIsInactiveFilterActive(filterType === "Inactive");
      setIsAllFilterActive(filterType === "All");
   };

   return (
      <>
         <div className="flex flex-wrap gap-2 mb-4">
            <div
               className={`h-10 border border-white/20  text-white flexc w-[170px] rounded-full cursor-pointer ${
                  isAllFilterActive ? "bg-[#303137]" : ""
               }`}
               onClick={() => handleFilter("All")}
            >
               All lead Sources
            </div>
            <div
               className={`h-10 border rounded-full border-white/20 flex items-center w-[170px] relative cursor-pointer ${
                  isActiveFilterActive ? "bg-[#303137]" : ""
               }`}
               onClick={() => handleFilter("Active")}
            >
               <Icon name="CheckCircle" className="fill-[#909196] ml-4" />
               <span className="absolute w-full mx-auto text-center">
                  Active
               </span>
            </div>
            <div
               className={`h-10 border rounded-full border-white/20 flex items-center w-[170px] relative cursor-pointer ${
                  isInactiveFilterActive ? "bg-[#303137]" : ""
               }`}
               onClick={() => handleFilter("Inactive")}
            >
               <Icon name="CloseCircle" className="fill-[#909196]  ml-4" />
               <span className="absolute w-full mx-auto text-center">
                  Inactive
               </span>
            </div>
            <div
               className={`h-10 border rounded-full border-white/20 flex items-center w-[170px] relative cursor-pointer ${
                  isPausedFilterActive ? "bg-[#303137]" : ""
               }`}
               onClick={() => handleFilter("Paused")}
            >
               <Icon
                  name="PauseCircle"
                  className="fill-[#909196] stroke-[#909196] ml-4"
               />
               <span className="absolute w-full mx-auto text-center">
                  Paused
               </span>
            </div>
            <div className="relative flex items-center w-10 h-10 ml-auto border rounded-full cursor-pointer border-white/20 flexc">
               <Icon name="Filter" />
            </div>
         </div>
         <SearchField
            iconClassName="fill-white/30"
            className="!w-full flexc !max-w-full"
            placeholder="Search for leads"
            value={searchTerm}
            onChange={handleSearch}
         />
         <table className="bg-[#222327] border border-white/10 rounded-lg w-full overflow-hidden mt-4">
            <tbody>
               <tr className="h-[70px] text-white text-[14px] font-medium bg-[#594180]">
                  <td colSpan={5}>
                     <div className="flex items-center px-9 gap-x-7">
                        <Icon name="TourIcon" />
                        <p>
                           Activate Auto nurture campaign on a lead source to
                           begin transforming your business
                        </p>
                     </div>
                  </td>
               </tr>
               <tr className="h-[70px] text-white/70 text-[14px]">
                  {columns.map((column, index) => (
                     <td key={index + column.title} className="px-4">
                        {column.title}
                     </td>
                  ))}
               </tr>
               {filteredData.map((data, index) => (
                  <tr
                     key={index + data.Lead_Source}
                     className={`h-[70px] align-middle font-medium border-b border-white/20 hover:bg-[#303137] cursor-pointer group ${
                        data.Status === "Active"
                           ? "bg-primary/50"
                           : data.Status === "Paused"
                           ? "bg-[#303137]"
                           : ""
                     }`}
                  >
                     <td className="w-1/5 px-4">{data.Lead_Source}</td>
                     <td className="w-1/5 px-4">{data.Total_leads}</td>
                     <td className="w-1/5 px-4">{data.App_set}</td>
                     <td className="w-1/5 px-4">
                        <div className="flex items-center gap-x-4">
                           <span>{data.App_rate}</span>

                           <div className="flexc bg-black/20 text-[14px] h-6 gap-x-2 w-16 rounded">
                              <Icon name="GreenArrow" />
                              <span>56%</span>
                           </div>
                        </div>
                     </td>
                     <td className="w-1/5 px-4 min-w-[300px]">
                        <div className="group-hover:hidden">
                           {data.Status === "Active" ? (
                              <div className="h-[30px] border rounded-full border-white/20 flex items-center w-[112px]  relative">
                                 <Icon
                                    name="CheckCircle"
                                    className="fill-[#B1E598] ml-1 top-[3px] absolute"
                                 />
                                 <span className="absolute w-full mx-auto text-center uppercase text-[10px] font-semibold">
                                    Active
                                 </span>
                              </div>
                           ) : data.Status === "Paused" ? (
                              <div className="h-[30px] border rounded-full border-white/20 flex items-center w-[112px] relative bg-[#d9d9d9]/20">
                                 <Icon
                                    name="PauseCircle"
                                    className="fill-[#E85075] stroke-[#E85075] ml-1 top-[3px] absolute"
                                 />
                                 <span className="absolute w-full mx-auto text-center uppercase text-[10px] text-white/70 font-semibold">
                                    Paused
                                 </span>
                              </div>
                           ) : (
                              <div className="h-[30px] border rounded-full border-white/20 flex items-center w-[112px]  relative">
                                 <Icon
                                    name="CloseCircle"
                                    className="fill-[#909196] ml-1"
                                 />
                                 <span className="absolute w-full mx-auto text-center uppercase text-[10px] text-white/70 font-semibold">
                                    Inactive
                                 </span>
                              </div>
                           )}
                        </div>
                        <div className="hidden group-hover:block ">
                           <div className="flex items-center gap-x-3">
                              <Button
                                 onClick={() =>
                                    data.Status === "inactive"
                                       ? openLeadDetailsModal
                                       : openActiveLeadDetailsModal
                                 }
                                 className="!min-w-[120px] !h-10 !bg-[#222327]/60 hover:!bg-[#222327] !font-medium !border-none !rounded !mt-0"
                              >
                                 View Stats
                              </Button>
                              <Button className="!min-w-[120px] !h-10 bg-[#594180]/60 !font-medium !border-none !rounded !mt-0">
                                 Activate
                              </Button>
                           </div>
                        </div>
                     </td>
                  </tr>
               ))}
            </tbody>
         </table>
         <LeadDetailsModal />
         <ActiveLeadDetailsModal />
      </>
   );
};
